export default "__VITE_ASSET__ByUO4Kzc__"